"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS = void 0;
var PRODUCTS = {
  INPUT__SEARCH: 'inventoryAdditionProducts-input-search',
  BUTTON__ADD_NEW_PRODUCT: 'inventoryAdditionProducts-button-addNewProduct',
  INPUT__BATCH_CODE: 'inventoryAdditionProducts-input-batchCode',
  INPUT__DATE_PICKER: 'inventoryAdditionProducts-input-datePicker',
  INPUT__QUANTITY: 'inventoryAdditionProducts-input-quantity',
  INPUT__COGS: 'inventoryAdditionProducts-input-cogs',
  BUTTON__SELECTED: 'inventoryAdditionProducts-button-selected',
  BUTTON__SELECT: 'inventoryAdditionProducts-button-select',
  ADD_NEW_PRODUCT: {
    BUTTON__CANCEL: 'inventoryAdditionAddNewProductModal-button-cancel',
    BUTTON__ADD_NEW_PRODUCT: 'inventoryAdditionAddNewProductModal-button-addNewProduct'
  }
};
exports.PRODUCTS = PRODUCTS;